import { LlmModel } from '@/libs/features/llm/types'
import type { PropType } from 'vue'

export type DevToolOptions = {
  temperature?: number | undefined
  maxResponseTokens?: number | undefined
  system?: string | undefined
  model?: LlmModel | undefined
}

export const LLM_DEV_TOOLS_PROPS = {
  modelValue: {
    type: Object as PropType<DevToolOptions>,
    required: true,
  },
  loading: {
    type: Boolean,
    required: true,
  },
} as const
